<p>
  input-step works!
</p>
